export const countEstimateYieldDay = (
  dayPrice?: number | null,
  rentalDays?: number | null,
) => {
  let estimatedYieldDay = null;
  if (dayPrice && rentalDays) {
    estimatedYieldDay = dayPrice * rentalDays;
  }
  return estimatedYieldDay;
};
